import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { StyledButton } from '@tryhackme/thm-ui-components';
import { ReactComponent as TwitterXIcon } from 'src/images/svgs/socials/x-twitter.svg';
import { ReactComponent as FacebookIcon } from 'src/images/svgs/socials/facebook.svg';
import { ReactComponent as LinkedinIcon } from 'src/images/svgs/socials/linkedin.svg';
import { useGetBadgesQuery } from 'src/features/badges/badges.slice';
import { facebookCampaignData, linkedinCampaignData, twitterCampaignData } from 'src/features/room/components/completion-modal/completion-modal.constants';
import { SegmentShareEvent } from 'src/common/types';
import { useGetUserQuery, useTrackEventMutation } from 'src/common/slices';
import { Achievement } from 'src/common/page-share';
import { StyledSocialButton } from 'src/common/styles';
import { StyledWrapperButtons } from '../../completion-modal.styles';
import { generateSocialMediaShareLink } from '../../completion-modal.helpers';
import { SocialName } from '../../completion-modal.types';
import { SocialSharingProps } from './social-sharing.types';
export const SocialSharing = ({
  roomType,
  roomCode,
  isCompletionShareRoomModal
}: SocialSharingProps) => {
  const {
    data: userData
  } = useGetUserQuery();
  const {
    data: badgesData
  } = useGetBadgesQuery();
  const [trackEvent] = useTrackEventMutation();
  const awardedBadge = badgesData?.data?.badges?.find(badge => badge.name === roomCode);
  const username = userData?.data?.user?.username;
  const trackShareClick = useCallback((event: SegmentShareEvent) => {
    const source = event.split('-')[1];
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'social-share',
      properties: {
        room_type: roomType,
        page: 'room',
        achievement: Achievement.room,
        name: roomCode ?? '',
        medium: source,
        clicked_on: isCompletionShareRoomModal ? 'roombanner-cta' : source
      }
    });
  }, [trackEvent, roomCode, isCompletionShareRoomModal, roomType]);
  return <StyledWrapperButtons data-sentry-element="StyledWrapperButtons" data-sentry-component="SocialSharing" data-sentry-source-file="social-sharing.tsx">
      {awardedBadge && <StyledButton as={Link} to={`/p/${username || ''}`} variant="solid" color="primary" target="_blank">
          Share Awarded Badge
        </StyledButton>}
      <StyledSocialButton data-social="twitter" href={generateSocialMediaShareLink(SocialName.TWITTER, roomCode, twitterCampaignData)} target="_blank" onClick={() => trackShareClick('share-twitter')} data-sentry-element="StyledSocialButton" data-sentry-source-file="social-sharing.tsx">
        <TwitterXIcon data-sentry-element="TwitterXIcon" data-sentry-source-file="social-sharing.tsx" />
        Twitter
      </StyledSocialButton>
      <StyledSocialButton data-social="facebook" href={generateSocialMediaShareLink(SocialName.FACEBOOK, roomCode, facebookCampaignData)} target="_blank" onClick={() => trackShareClick('share-facebook')} data-sentry-element="StyledSocialButton" data-sentry-source-file="social-sharing.tsx">
        <FacebookIcon data-sentry-element="FacebookIcon" data-sentry-source-file="social-sharing.tsx" />
        Facebook
      </StyledSocialButton>
      <StyledSocialButton data-social="linkedin" href={generateSocialMediaShareLink(SocialName.LINKEDIN, roomCode, linkedinCampaignData)} target="_blank" onClick={() => trackShareClick('share-linkedin')} data-sentry-element="StyledSocialButton" data-sentry-source-file="social-sharing.tsx">
        <LinkedinIcon data-sentry-element="LinkedinIcon" data-sentry-source-file="social-sharing.tsx" />
        Linkedin
      </StyledSocialButton>
    </StyledWrapperButtons>;
};